// extracted by mini-css-extract-plugin
module.exports = {"link":"SignupForm_link__1EPt6","link-open-modal":"SignupForm_link-open-modal__I_Dhj","mr-1":"SignupForm_mr-1__21p3z"};